import { X } from "lucide-react";
import { memo } from "react";

import { Badge } from "@/components/ui/badge";

import type { IShareSelectedChipProps } from "./types";

// NOTE: Capped at 14rem, and never wider than the chip row itself — at 390px the
// row is narrower than 14rem, and a fixed cap let a long name overflow it.
const ShareSelectedChipComponent = ({
  label,
  removeAriaLabel,
  onRemove,
  testId,
}: IShareSelectedChipProps): JSX.Element => (
  <Badge
    variant="secondary"
    data-testid={testId}
    className="h-6 min-w-0 max-w-[min(14rem,100%)] gap-1 rounded-full py-0 pe-1 ps-2.5 text-xs font-medium"
  >
    <span dir="auto" className="truncate">
      {label}
    </span>
    <button
      type="button"
      onClick={onRemove}
      aria-label={removeAriaLabel}
      className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-foreground/10 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <X className="h-3 w-3" />
    </button>
  </Badge>
);

export const ShareSelectedChip = memo(ShareSelectedChipComponent);

ShareSelectedChip.displayName = "ShareSelectedChip";
